import { paymentCardNumberFactory } from '@mews/framework';
import { TextInput } from '@optimus-web/core';

// @ts-expect-error $TSFixMeError: Argument of type 'ForwardRefExoticComponent<Pick<FieldProps & InputProps & RefAttributes<HTMLInputElement>, "value" | "c...
export const PaymentCardNumber = paymentCardNumberFactory(TextInput);
